<template lang="pug">
  div.wrap-module-page-changer
    div.changer-header.f.fm.flex-between.px8
      span Select page
      v-icon(@click="$emit('togglePageChanger')") mdi-close
    div.page-changer-content.px8.py6
      div(v-for="page in pages"
        @click="toPage(page.id)").wrap-page.f.fh.mb6.cursor-pointer
        v-img(:src="page.imgURL")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-page-changer {
  position: fixed;
  top: 0;
  left: 0;
  width: 240px;
  height: 100vh;
  z-index: 200;
  background: $primary_bg_color;
  .changer-header {
    height: $header_height;
    border-bottom: $basic_border;
  }
  .page-changer-content {
    height: calc(100vh - #{$header_height});
    overflow: scroll;
    .wrap-page {

    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')

export default {
  components: {
  },
  props: {
    pages: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {
      isUpdating: false
    }
  },
  created () {
    // debugger
  },
  methods: {
    async toPage (pageId) {
      if (this.isUpdating) return
      this.isUpdating = true
      console.log('pageId:', pageId)
      await database.slideCollection().update(this.$route.params.slideId, {
        currentPage: pageId
      })
      this.$emit('togglePageChanger')
      this.isUpdating = false
    }
  }
}
</script>
